import CollectionFilters from "./modules/CollectionFilters";
import CustomSelect from "./modules/CustomSelect";
//import Slider from "./modules/Slider"
import * as Filters from "./modules/Filters"
import CollectionPagination from "./modules/CollectionPagination"
import CollectionBannersTest from "./modules/CollectionBannersTest"
import SortingOptimizer from "./modules/external-systems/dynamic-yield/SortingOptimizer"
// import "./apps-react/AppMain"
// import "./modules-react___old/CollectionFilters/CollectionFilters"
const $_selects = [...document.querySelectorAll('.custom-select')];
let collectionPagination = null;
let paginationObserver = null;

function initCollectionPagination() {
    const pagination = document.querySelector('.template-collection__products .pagination__wrapper')

    if (collectionPagination) {
        collectionPagination.refresh();
        return;
    }

    if (!pagination) {
        return;
    }

    collectionPagination = new CollectionPagination();
    paginationObserver?.disconnect();
}

new CollectionFilters();
new CollectionBannersTest();
if ($_selects.length) {
    new CustomSelect($_selects);
}
initCollectionPagination();

if (!collectionPagination && window.MutationObserver) {
    paginationObserver = new MutationObserver(initCollectionPagination);

    paginationObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
    });
}

document.addEventListener('shopify:section:load', initCollectionPagination);
document.addEventListener('shopify:section:select', initCollectionPagination);

new SortingOptimizer();
